export const EMPIRE_CODE = "Empire Code:";
export const PRODUCT_NAME = "Product Name:";
export const PRODUCT_DESCRIPTION = "Product Description:";
export const DESCRIPTION = "Description";
export const SHORT_DESCRIPTION = "Short Description:";
export const COMMERCIAL_DESCRIPTION = "Commercial Description";
export const MORE_INFORMATION = "More Information";
export const CT_PORTFOLIO = "CT Portfolio:";
export const PRODUCT_RESOURCES = "PRODUCT RESOURCES";
export const PRODUCT_RESOURCES_NO_ARTIFACTS = "There are currently no resources available for this product.";
export const PRODUCT_RESOURCE_DOWNLOAD_LABEL = "Download";
export const PRODUCT_RESOURCE_VISIT_LINK_LABEL = "Visit link";
export const GLOBAL_SERVICE_CODE = "PRODUCT GLOBAL SERVICE CODE";
export const GLOBAL_SERVICE_CODE_PRIMARY_LIST =
  "Global Service Code Primary List:";
export const GLOBAL_SERVICE_CODE_SECONDARY_LIST =
  "Global Service Code Secondary List:";
export const PRODUCT_CONTACTS = "Product Contacts";
export const COMMERCIAL_OWNER_NAME = "Commercial Owner Name:";
export const COMMERCIAL_OWNER_PROXY_NAME = "Commercial Owner Proxy Name:";
export const PRODUCT_OWNER_NAME = "Product Owner Name";
export const CT_PRODUCT_MANAGER = "CT Technical Product Manager:";
export const SUPPORT = "Support";
export const ORDER_ACKNOWLEDGEMENT = "Order acknowledgment";
export const GLOBAL_RISK_MANAGER = "Global Risk Manager";
export const GLOBAL_RISK_MANAGER_FIELD = "global_risk_manager";
export const LOCAL_RISK_MANAGER = "Local Risk Manager";
export const PRODUCT_APPROVER = "Product Approver";
export const PROVISIONING_TEAM = "Provisioning Team";
export const DEMAND_MANAGEMENT_TEAM_ID = "Demand Management Teams ID:";
export const TEAM_EMAIL_ID = "Team Email ID:";
export const SUPPORT_LINK = "Support Link:";
export const SUPPORT_LINK_NAME = "Name to appear in Commercial Hub";
export const SKUS = "SKUs";
export const CREATE_NEW_SKUS = "Create New SKUS";
export const SAVE_DRAFT = "Save Draft";
export const CANCEL = "Cancel";
export const REJECT = "Reject";
export const APPROVE = "Approve";
export const PRIMARY_LIST_PLACEHOLDER = "Primary List";
export const SECONDARY_LIST_PLACEHOLDER = "Secondary List";
export const EMAIL_ID_PLACEHOLDER = "Email ID";
export const PRODUCT_SUPPORT_LINK = "Enter URL";
export const PRODUCT_CONTACT_PLACEHOLDER = "Product Contact";
export const EMPIRE_CODE_PLACEHOLDER = "Empire Code (required)";
export const PRODUCT_COST_SETUP = "Product Cost Setup";
export const PRODUCT_DETAILS_LABEL = "Product Details";
export const DOWNLOAD_API_KEYS = "Download API Keys";
export const DEMAND_MANAGEMENT_TEAM_ID_LABEL =
  "CT Demand Management support group | General | Microsoft Teams";
export const DEMAND_MANAGEMENT_TEAM_ID_URL =
  "https://teams.microsoft.com/dl/launcher/launcher.html?url=%2F_%23%2Fl%2Fchannel%2F19%3A749l0Wc1ulYbzkITs19wktovOBkRpIaJIeQgk21pNaM1%40thread.tacv2%2FGeneral%3FgroupId%3D68d8f316-4338-4e6b-95eb-eb1366bd0058%26tenantId%3D5b973f99-77df-4beb-b27d-aa0c70b8482c&type=channel&deeplinkId=b2244765-8ee9-4d7d-980e-ab0d3d50e1e3&directDl=true&msLaunch=true&enableMobilePage=true&suppressPrompt=true";
export const BMO_LABEL = "Business Management Office Team";
export const BMO_DESCRIPTION =
  "The BMO (Business Management Office) Team is a core functional group who has key inputs for product cost rate calculations, SKU governance, and billing type management with the organization. They act as a nexus between the Commercial Owners, Business Product Manager, and CT Product Managers, ensuring precision, compliance, and efficiency in the management of product cost information and associated workflows. The main goal is to ensure all product SKUs are accurately reviewed, all cost rates are correctly calculated, and billing types are assigned in accordance with the enterprise policies and compliance requirements.";
export const SKU_APPROVE = "skuapprove";
export const SKU_APPROVE_COST_TYPE = "skuapprovecost";
export const APPROVE_RETURN = "approvereturn";
export const REJECT_RETURN = "rejectreturn";
export const SKU_REJECT = "skureject";
export const SKU_REJECT_COST_TYPE = "skurejectcost";
export const BMO_SKU_EDIT = "bmoskuedit";
export const CFO_APPROVAL_UPLOAD_MESSAGE =
  "Please upload a file that includes the CFO’s approval.";
export const SKU_COST_EFFECTIVE_DATE_NOTE =
  "Once approved, the new SKU cost will take effect on the published cost date, unless the commercial owner cancels the request beforehand.";
export const SKU_AVAILABLE_FOR_PURCHASE_IN_COMMERCIAL_HUB_MESSAGE =
  "Once approved, this SKU will be available for purchase in the Commercial Hub.";
export const CFO_APPROVAL = "CFO approval*";
export const ALLOWED_EXTENSIONS = [
  "png",
  "pdf",
  "docx",
  "doc",
  "msg",
] as const;
export const UPLOAD_DURATION = 2000; // 2 seconds
export const UPDATE_INTERVAL = 50; // 50ms
export const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15 MB
